import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { formatMoney, priceBundle, startingPrice } from '../../utils/pricing';
import { freeShippingLive, pricingConfig } from '../../data/pricing';

/** Offer bar — every value derives from the central pricing config. */
export function AnnouncementBar() {
  const {
    lang
  } = useLanguage();
  const es = lang === 'es';
  const from = formatMoney(startingPrice(), lang);
  const maxSave = formatMoney(Math.max(...pricingConfig.bundles.map(b => priceBundle(b).savings)), lang).replace(/\.00$/, '');
  return <div className="border-b border-marine/25 bg-[#0A2747] text-white" data-id="element-435" data-mp="10cof1978wedx">
      <div className="mx-auto flex max-w-site items-center justify-center gap-4 px-4 py-2 text-center font-display text-[13px] font-semibold uppercase tracking-[0.12em] sm:text-[14px]" data-id="element-436" data-mp="10bdcfcpjdcoe">
        {freeShippingLive() ? <span data-id="element-437" data-mp="2gqy1fxrxft24">{es ? 'Envío gratis en EE.UU. · Todos los pedidos' : 'Free U.S. shipping · Every order'}</span> : <span data-id="element-438" data-mp="10bnyhhonqx32">
            {es ? 'Sistemas M1 PRO desde ' : 'M1 PRO systems starting at '}
            <span className="text-ice" data-id="element-439" data-mp="w913x90lqy26">{from}</span>
          </span>}
        <span aria-hidden className="hidden text-marine md:inline" data-id="element-440" data-mp="rahfn1yjda6n">•</span>
        <span className="hidden md:inline" data-id="element-441" data-mp="r8mvhpv39m3m">
          {es ? 'Ahorra hasta ' : 'Save up to '}
          <span className="text-ice" data-id="element-442" data-mp="mb4tkjfho754">{maxSave}</span>
          {es ? ' en sistemas completos' : ' on complete systems'}
        </span>
        <span aria-hidden className="hidden text-marine xl:inline" data-id="element-443" data-mp="cllb3evoufas">•</span>
        <span className="hidden xl:inline" data-id="element-444" data-mp="cjgvhzoffruo">{es ? 'Garantía de por vida en sistemas de 4+ luces' : 'Lifetime Warranty on 4+ light systems'}</span>
      </div>
    </div>;
}